import React from "react";
import IndexCardView from "../cards/IndexCardView";

const EventsAndIndexes = ({ 
  indexes, 
  styleCardSize, 
  activeEvents,
  visualEffects,
  onPurchaseIndex,
  onSellIndex,
  canPurchaseIndex,
  canSellIndex,
  playerIndexPortfolios = {},
  playerName = "",
  indexOwnershipByPlayer = {},
  playerColors = {},
  playerEmojis = {},
  myTurn = false,
  actionMode = null,
  selectedActionCard = null,
  onApplyAction = null,
  roundNumber = 1
}) => {
  return (
    <div className="indexes-centered" data-tutorial="indexes">
      {/* Index Cards - Aligned to top */}
      {indexes.map((index, i) => {
        if (!index) return null;
        
        const ownedIndex = (playerIndexPortfolios[playerName] || []).find(
          (owned) => owned.name === index.name
        ) || null;

        // Transform indexOwnershipByPlayer from { playerName: { indexName: [...] } }
        // to { playerName: [...] } for this specific index (use pName to avoid shadowing playerName)
        const ownershipForThisIndex = {};
        Object.keys(indexOwnershipByPlayer).forEach((pName) => {
          if (indexOwnershipByPlayer[pName] && indexOwnershipByPlayer[pName][index.name]) {
            ownershipForThisIndex[pName] = indexOwnershipByPlayer[pName][index.name];
          }
        });

        // Get the last purchased index for ROI calculation (most recent purchase)
        // ownershipForThisIndex structure: { playerName: [{ purchasePrice, purchaseRound }, ...] }
        const playerOwnership = ownershipForThisIndex[playerName] || [];
        // Get the last (most recent) purchase - arrays are ordered by purchase order
        const lastPurchasedIndex = playerOwnership.length > 0 
          ? playerOwnership[playerOwnership.length - 1] 
          : null;
        // Calculate ROI in dollar terms: sellPrice - purchasePrice
        // Note: Indexes sell at current market price (no tax), so sellPrice = index.price
        const sellPrice = index ? index.price : 0;
        const roi = lastPurchasedIndex && index && sellPrice 
          ? (sellPrice - lastPurchasedIndex.purchasePrice).toFixed(2)
          : null;

        const isCrypto = index.name === "crypto";
        return (
          <div 
            key={`index-${i}`} 
            className="index-card-item"
            data-tutorial={isCrypto ? "crypto-index" : "regular-index"}
          >
          <IndexCardView 
              ix={index} 
            styleCardSize={styleCardSize} 
            activeEvents={activeEvents} 
            visualEffects={visualEffects} 
              onPurchase={onPurchaseIndex}
              onSell={onSellIndex}
              canPurchase={canPurchaseIndex}
              canSell={canSellIndex && ownedIndex}
              ownedIndex={ownedIndex}
              indexOwnershipByPlayer={ownershipForThisIndex}
              playerColors={playerColors}
              playerEmojis={playerEmojis}
              roundNumber={roundNumber}
              roi={roi}
              myTurn={myTurn}
              actionMode={actionMode}
              selectedActionCard={selectedActionCard}
              onApplyAction={onApplyAction}
          />
        </div>
        );
      })}
    </div>
  );
};

export default EventsAndIndexes;